import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { DialogContainer } from '@handlers/sessions/components/dialog'
import React from 'react'
import { useClinicianTelehealthSession } from '../context/clinician-telehealth-session.context'

export interface AdmitWaitingParticipantDialogProps {
  isOpen: boolean
  onClose?: () => void
  onAdmit?: () => void
  requestingParticipantName?: string
}

export const AdmitWaitingParticipantDialog = ({
  isOpen,
  onClose = () => {},
  onAdmit = () => {},
  requestingParticipantName
}: AdmitWaitingParticipantDialogProps) => {
  const { patient, setIsEndSessionModalOpen } = useClinicianTelehealthSession()

  return (
    <DialogContainer size="md" isOpen={isOpen} onClose={onClose}>
      <Box p="medium">
        <Text fontWeight="bold" fontSize="18px">
          Are you sure you want to admit {requestingParticipantName} into{' '}
          {patient?.first_name}'s session?
        </Text>
        <Text my="small">
          If you instead wish to start a new session with{' '}
          {requestingParticipantName}, end this session first and start a new
          session.
        </Text>
        <Flex alignItems={'center'} justifyContent={'space-between'}>
          <Box>
            <Button
              m="0px"
              bg="error"
              borderRadius="8px"
              size="sm"
              onClick={() => {
                onClose()
                setIsEndSessionModalOpen(true)
              }}
              data-click-text="End current session"
            >
              End current session
            </Button>
          </Box>
          <Box>
            <Button
              borderRadius="8px"
              size="sm"
              mr="8px"
              variant="outline"
              onClick={onClose}
              data-click-text="Close"
            >
              Close
            </Button>
            <Button
              m="0px"
              borderRadius="8px"
              size="sm"
              onClick={onAdmit}
              data-click-text="Admit"
            >
              Admit
            </Button>
          </Box>
        </Flex>
      </Box>
    </DialogContainer>
  )
}
